module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921065651_T.9658179c.jpg";